import { useEffect } from "react";

import {
  useSbsCellState,
  type SbsCellStateMap,
} from "./PlanEditor/context/SbsCellStateContext";

// Pushes the derived "different than requested" flags into the cell state
// provider. Unlike AiCellStateSyncer, an empty map is applied: it means every
// flag was dismissed or resolved, and leaving the old shading up would be wrong.
export const DifferenceCellStateSyncer = ({
  differenceMap,
}: {
  differenceMap: SbsCellStateMap;
}): null => {
  const { setDifferenceMap } = useSbsCellState();

  useEffect(() => {
    setDifferenceMap(differenceMap);
  }, [differenceMap, setDifferenceMap]);

  return null;
};
